/* eslint-disable import/prefer-default-export */
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Dispatch, ReactNode, SetStateAction } from "react";

type SelectFormProps = {
  id: string;
  label: string;
  optionList: string[] | readonly string[] | {dispName: string, value: string}[];
  value: string;
  setValue: Dispatch<SetStateAction<string>> | Function;
  required?: boolean;
  disabled?: boolean;
  isContainBlank?: boolean;
  fullWidth?: boolean;
  minWidth?: number;
  maxWidth?: number | string;
  renderValue?: ((value: string) => ReactNode);
  dummyValues?: string[]; // 候補に表示はされず選択もできないが、初期表示はされるようにする
};

/**
 * 選択フォーム
 * @param root0 選択フォームのプロップス
 * @returns JSX.Element
 */
export function SelectForm({
  id,
  label,
  optionList,
  value,
  setValue,
  required,
  disabled,
  isContainBlank,
  fullWidth,
  minWidth = 160,
  maxWidth = 'none',
  renderValue,
  dummyValues,
}: SelectFormProps) {
  return (
    <Box width={fullWidth ? "100%" : "50%"} m={0} minWidth={minWidth}>
      <Box p={1}>
        <FormControl sx={{ minWidth, width: "100%", maxWidth }} required={required}>
          <InputLabel
            id={`${id}-label`}
            sx={{
              top: "-6px",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -4px) scale(0.75)",
              },
              "& .MuiFormLabel-asterisk": {
                color: "var(--red-800)",
              },
            }}
          >
            {label}
          </InputLabel>
          <Select
            labelId={`${id}-label`}
            label={label}
            id={id}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            sx={{ height: "40px" }}
            disabled={disabled}
            renderValue={renderValue}
          >
            {isContainBlank && (
              // eslint-disable-next-line no-irregular-whitespace, react/self-closing-comp
              <MenuItem key="" value="">
                &emsp;
              </MenuItem>
            )}
            {dummyValues && // 初期値としては表示するが選択肢には表示しない値
              dummyValues.map((dVal) => (
                <MenuItem key={dVal} value={dVal} disabled sx={{display: 'none'}}>{dVal}</MenuItem>
              ))
            }
            {optionList.map((s) => typeof s === "string" ? (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ) : (
              <MenuItem key={s.value} value={s.value}>
                {s.dispName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}
